module.exports = __webpack_public_path__ + "img/nuncacompraram.ffb38d73.png";